import type { LevelConfig } from '../types'
import { padRow } from '../utils'

export const level3: LevelConfig = {
  grid: [
    padRow(
      [
        { track: 'WE', exit: 'W' },
        'WE',
        ['WE', 'SW'],
        { track: 'WE', vehicle: { type: 'wagon', color: 'darkorange', direction: -1 } },
        { track: 'WE', vehicle: { type: 'wagon', color: 'aqua', direction: -1 } },
        'WE',
        ['WE', 'SE'],
        { track: 'WE', vehicle: { type: 'locomotive', direction: -1 } },
        'E',
      ],
      'prepend',
    ),
    padRow([null, null, 'NE', 'WE', 'WE', 'WE', 'NW'], 'prepend', false),
  ],
  goal: {
    sequence: ['aqua', 'darkorange'],
  },
}
